import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
  	flex: 1,
  	display: 'flex',
    flexDirection: 'column',
  },
}));

export default useStyles;